export const parseCurrency = (value?: string | null): number => {
  if (!value) return 0;

  // Remove currency symbols and commas
  const parsed = Number(value.replace(/[^0-9.-]+/g, ''));

  return Number.isNaN(parsed) ? 0 : parsed;
};
